import RiskPage from "./RiskPage";
export default RiskPage